export function downloadTextFile(text: string, fileName: string): void {
  const blob = new Blob([text], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  // Must be attached to the document for the click to reliably trigger a
  // download in Firefox/Safari (an unattached anchor's click is silently a
  // no-op in both) — appended immediately before the click, removed right
  // after. `revokeObjectURL` is deferred a tick (not called synchronously
  // right after `click()`) since both browsers start the actual download
  // asynchronously; revoking the URL before that starts would fail it too.
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
